
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetomumbaidarshanbusonrent() {



  const cardData =
  {
    keyword: ' Pune to Mumbai Darshan Bus on Rent',
    heading: 'Vaishnavi Travels: Pune to Mumbai Darshan Bus on Rent',
    headingDescription: 'Vaishnavi Travels offers affordable and convenient Pune to Mumbai Darshan Bus on Rent, making sightseeing and group travel comfortable and stress-free. Our buses are spacious, well-maintained, and equipped with push-back seats, strong air-conditioning, and ample luggage space to ensure a smooth journey for families, school groups, and corporate teams. With professional drivers, timely service, and flexible booking options, we provide a hassle-free experience while covering major attractions in Mumbai. Whether it’s a one-day city tour, a religious yatra, or a group outing, Vaishnavi Travels guarantees safe, reliable, and enjoyable Pune to Mumbai Darshan bus rental services.',

    top: 'Top Places to Visit in Mumbai with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],

"services": [
{
"name": "Mumbai Darshan Bus Pune Booking",
"description": "Convenient booking service for Mumbai Darshan buses from Pune, providing comfortable and reliable transportation for groups planning to explore Mumbai’s iconic landmarks. Our buses come equipped with modern amenities, ensuring a smooth and enjoyable journey for tourists, families, and corporate groups alike. Flexible scheduling and professional drivers make your Mumbai Darshan hassle-free and memorable."
},
{
"name": "Pune to Mumbai City Tour Bus",
"description": "Comprehensive Pune to Mumbai city tour bus service offering round-trip transportation with experienced drivers and well-maintained buses. Ideal for sightseeing, family outings, and group tours, these buses provide spacious seating and optional air conditioning for a comfortable ride. Customize your itinerary to include key Mumbai attractions while enjoying stress-free travel."
},
{
"name": "AC Tourist Bus for Mumbai Darshan",
"description": "Premium air-conditioned tourist buses designed for Mumbai Darshan tours from Pune, ensuring a cool and relaxing travel experience regardless of the season. These buses feature cushioned seats, ample legroom, and onboard entertainment options, perfect for long-distance trips. Suitable for family groups, school tours, and corporate outings seeking a luxury travel experience."
},
{
"name": "Mumbai Sightseeing Bus Pune",
"description": "Specialized sightseeing bus service from Pune to Mumbai, tailored to showcase the city's cultural, historical, and entertainment hotspots. Our buses offer guided tour options, comfortable seating, and flexible pick-up points in Pune, making it easy to explore Mumbai’s attractions without logistical hassles. Ideal for tourists and educational groups."
},
{
"name": "Pune to Mumbai Day Tour Bus",
"description": "Efficient day tour bus service from Pune to Mumbai, perfect for travelers looking to spend a full day exploring Mumbai’s famous sites. Includes timely pickups and drop-offs, with rest stops and refreshments available during the journey. Our vehicles are well-maintained and operated by professional drivers to ensure a safe and enjoyable trip."
},
{
"name": "Mumbai Darshan Group Travel Bus",
"description": "Group travel bus solutions for Mumbai Darshan tours departing from Pune, catering to large families, corporate teams, and tour groups. Buses come in various sizes including 45-seaters, with options for AC and non-AC vehicles. We provide customizable routes and schedules to fit your group’s specific needs, along with friendly driver assistance."
},
{
"name": "Local Tour Bus Pune to Mumbai",
"description": "Reliable local tour bus service connecting Pune and Mumbai, offering convenient and affordable travel options for day trips and multi-day tours. Our buses are equipped with essential amenities and driven by skilled drivers familiar with both cities, ensuring a smooth and punctual journey."
},
{
"name": "Darshan Bus for Family Group",
"description": "Comfortable and spacious Darshan bus rentals for family groups traveling from Pune to Mumbai. Designed to accommodate all ages with ample luggage space, safe seating, and climate control options, these buses make family outings stress-free and enjoyable. Decoration and refreshment services available on request."
},
{
"name": "Pune to Mumbai Outstation Bus Hire",
"description": "Specialized outstation bus hire service for trips from Pune to Mumbai, offering a range of vehicles suited for various group sizes and budgets. Our outstation buses are regularly maintained, insured, and staffed by experienced drivers knowledgeable of the Pune-Mumbai route for efficient travel."
},
{
"name": "45 Seater Darshan Bus Pune",
"description": "Spacious 45 seater buses perfect for Mumbai Darshan group tours departing from Pune. These buses provide comfortable seating, large windows for sightseeing, and onboard amenities including air conditioning and charging ports. Ideal for corporate outings, school trips, and large family groups seeking comfortable group travel."
},
{
"name": "School Tour Mumbai Bus",
"description": "Safe and reliable bus rental service for school tours from Pune to Mumbai, ensuring child-friendly seating arrangements, timely pickups, and well-trained drivers. Our buses comply with safety regulations and provide comfortable travel for students and teachers during educational excursions."
},
{
"name": "Book Mumbai Tourist Bus Online",
"description": "Easy online booking platform for Mumbai tourist buses departing from Pune, offering instant quotes, secure payments, and customizable options like AC, non-AC, and vehicle size. Our platform includes customer support and real-time tracking, making group travel planning simple and transparent."
},
{
"name": "Pune to Mumbai Picnic Bus",
"description": "Fun and affordable picnic bus rentals for groups traveling from Pune to Mumbai for day trips or weekend getaways. Equipped with comfortable seating, music systems, and large luggage compartments, these buses are perfect for family picnics, friends’ outings, and casual group tours."
}
],
"tableData": [
["Mumbai Darshan Bus Pune Booking", "Pune to Mumbai City Tour Bus"],
["AC Tourist Bus for Mumbai Darshan", "Mumbai Sightseeing Bus Pune"],
["Pune to Mumbai Day Tour Bus", "Mumbai Darshan Group Travel Bus"],
["Local Tour Bus Pune to Mumbai", "Darshan Bus for Family Group"],
["Pune to Mumbai Outstation Bus Hire", "45 Seater Darshan Bus Pune"],
["School Tour Mumbai Bus", "Book Mumbai Tourist Bus Online"],
["Pune to Mumbai Picnic Bus"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Mumbai Darshan Bus on Rent",
    "WhyChoosedescription": "Vaishnavi Travels offers dependable bus rental services for Pune to Mumbai darshan tours, ensuring a comfortable and hassle-free journey."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Seating",
    "WhyChoosedescription": "Our buses provide ample legroom and cushioned seats to make your Mumbai darshan trip enjoyable and relaxing."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to maintain high safety and hygiene standards."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored for Darshan Trips",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options that fit your Pune to Mumbai darshan itinerary."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Route",
    "WhyChoosedescription": "Our professional drivers ensure safe, timely, and courteous service, with expert knowledge of the Pune to Mumbai route."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy all-inclusive pricing covering fuel, tolls, taxes, and driver allowances for a stress-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Religious Tours, Group Travel, and Events",
    "WhyChoosedescription": "Perfect for darshan tours, corporate outings, weddings, and large group travel between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Vaishnavi Travels provides round-the-clock assistance for bookings, itinerary changes, and travel inquiries."
  }
]





















  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide Pune to Mumbai Darshan bus rental services?',
      answer: 'Yes, Vaishnavi Travels offers comfortable and reliable Pune to Mumbai Darshan bus rentals. Our buses are ideal for sightseeing tours, group visits, and religious darshan trips between Pune and Mumbai.',
    },
    {
      question: 'What types of buses are available for Pune to Mumbai Darshan trips?',
      answer: 'We provide a variety of buses including 32 seater tempo travellers, 40 to 50 seater coaches, both AC and non-AC, suited to your group size and comfort preferences.',
    },
    {
      question: 'What are the approximate rental charges for Pune to Mumbai Darshan bus services?',
      answer: 'Rental costs vary depending on the bus type and duration, but typically start around ₹10,000 for a day trip for a 32 seater tempo traveller. Exact quotes are provided based on your itinerary.',
    },
    {
      question: 'Are drivers included in the Pune to Mumbai Darshan bus rental?',
      answer: 'Yes, all our rentals include professional, experienced drivers who know the Pune-Mumbai route well and ensure a safe and timely journey.',
    },
    {
      question: 'Can I customize the itinerary for the Mumbai Darshan trip?',
      answer: 'Absolutely. We can tailor the stops and timings based on your preferred darshan spots, sightseeing locations, and schedule requirements.',
    },
    {
      question: 'How far in advance should I book the Pune to Mumbai Darshan bus?',
      answer: 'Booking at least 3-5 days in advance is recommended to ensure availability, especially during weekends, holidays, and festival seasons.',
    },
    {
      question: 'Are tolls, parking, and other charges included in the fare?',
      answer: 'Tolls, parking fees, and driver allowances are usually extra and will be clearly communicated in your rental quote to avoid surprises.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Sandeep Kulkarni",
    position: "Travel Enthusiast",
    feedback:
      "We booked a Pune to Mumbai Darshan bus with Vaishnavi Travels for a family trip. The bus was spacious and comfortable, and the driver was punctual and courteous. The trip was smooth and enjoyable, highly recommend their service.",
    rating: 5,
  },
  {
    name: "Mrs. Anjali Joshi",
    position: "Event Organizer",
    feedback:
      "Vaishnavi Travels provided excellent bus service for our group’s Mumbai darshan tour. The bus was clean, air-conditioned, and the driver was knowledgeable about the route. The booking process was hassle-free and transparent.",
    rating: 5,
    style: "style-2",
  }
];



















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Darshan Bus on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-mumbai-darshan-bus.jpg",
  "description": "Book Pune to Mumbai Darshan bus on rent with Vaishnavi Travels for comfortable, AC tourist buses ideal for sightseeing, group travel, school tours, and family picnics.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "1750"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-mumbai-darshan-bus-on-rent"
  }
};



  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Darshan Bus on Rent | AC Tourist Bus for Mumbai Sightseeing | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Pune to Mumbai Darshan bus on rent with Vaishnavi Travels for comfortable, AC tourist buses ideal for sightseeing, group travel, school tours, and family picnics."
  />
  <meta
    name="keywords"
    content="Mumbai Darshan Bus Pune Booking, Pune to Mumbai City Tour Bus, AC Tourist Bus for Mumbai Darshan, Mumbai Sightseeing Bus Pune, Pune to Mumbai Day Tour Bus, Mumbai Darshan Group Travel Bus, Local Tour Bus Pune to Mumbai, Darshan Bus for Family Group, Pune to Mumbai Outstation Bus Hire, 45 Seater Darshan Bus Pune, School Tour Mumbai Bus, Book Mumbai Tourist Bus Online, Pune to Mumbai Picnic Bus"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaidarshanbusonrent;